import type { ExplicitToolConfig, SafeToolInfo, ToolWithPublishedConfigAndCategories } from '@magicschool/business-logic/tools';
import type { Tables } from '@magicschool/supabase/types';

export const emptyAdminToolDetails = (): ToolWithPublishedConfigAndCategories => ({
  tool: emptyTool(),
  published_config: emptyToolConfig(),
  categories: [],
  iconName: null,
  model: emptyModel(),
});

export const emptySafeToolDetails = (): SafeToolInfo => ({
  tool: emptyTool(),
  categories: [],
  iconName: null,
  fields: [],
  modelSlug: '',
  studioModeEnabled: false,
  webSearchEnabled: false,
  knowledgeBaseEnabled: false,
});

export const emptyTool = () => ({
  id: '',
  title: '',
  description: '',
  icon: '',
  priority: 0,
  roles: [],
  roles_text: null,
  created_at: null,
  published_config_id: '',
  is_hidden: false,
  is_new: false,
  is_hero: false,
  slug: '',
  tags: [],
  updated_at: null,
  is_hot: false,
  assistant_tool_type: null,
  toolCustomizationId: null,
  icon_category_id: null,
});

export const emptyToolConfig = (): ExplicitToolConfig => ({
  archived: false,
  created_at: '',
  fields: [],
  frequency_penalty: 0,
  id: '',
  max_length: 0,
  model_id: '',
  name: '',
  presence_penalty: 0,
  prompt: '',
  publish_date: null,
  published_by: null,
  created_by: null,
  system_message: '',
  studio_mode_enabled: false,
  temperature: 0,
  tool_id: '',
  top_p: 0,
  updated_at: null,
  full_model: emptyModel(),
  translation_mode: 'basic',
  use_standards_tool: false,
  web_search_enabled: false,
  knowledge_base_enabled: false,
  semantic_search_context: null,
});

export const emptyModel = (): Tables<'llm_models'> => ({
  id: '',
  slug: '',
  created_at: '',
  label: '',
  provider: 'openai',
  context_window_tokens: 0,
  max_output_tokens: 0,
  websearch_model_id: null,
  supports_web_search: false,
  status: 'active',
  updated_at: null,
});
